import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {Route,Link } from 'react-router-dom';

import {config} from "../constants/domainConfig";
import PrivateRoute from './../PrivateRoute'

// Containers
import Login from '../components/Login/Login';
import twoStepLogin from '../components/Login/twoStepLogin'
import Page404 from './Page404';
import Page500 from './Page500';
import AccessDenied from './AccessDenied';
import CokiesPolicy from './CokiesPolicy';
import Home from './Home';
import Welcome from './Welcome';

// Components
import Header from '../components/Header/Header';
import ActivityIndicator from '../components/ActivityIndicator/ActivityIndicator';
import Sidebar from '../components/Sidebar/Sidebar';
import BottomMobileMenu from '../components/BottomMobileMenu/BottomMobileMenu';
import Footer from '../components/Footer/Footer';
import Overlay from '../components/Sidebar/Overlay';
import SplashScreen from '../components/SplashScreen/SplashScreen';
import CookieConsent from "react-cookie-consent";
import Feedback from "../components/feedback/feedback";
import ReactGA from 'react-ga';
import { FormattedMessage } from 'react-intl';

//adding google analytics
ReactGA.initialize('UA-96031156-4');
ReactGA.pageview(window.location.href);

import {detect} from 'detect-browser';
const browser = detect();
const minBrowserVersions = {
    chrome: '52',
    edge: '10',
    firefox: '52',
    ie: '10',
    opera: '16',
    safari: '7',
}
class App extends Component {
    constructor(props) {
        super(props);
        this.state={
            feedbackModal: false
        }

        this.showSearch = this.showSearch.bind(this);
        this.showMenu = this.showMenu.bind(this);
        this.hideHomeRoute = this.hideHomeRoute.bind(this);
        this.feedbackModalToggle=this.feedbackModalToggle.bind(this);
    }

    showSearch() {
        let hideSearchRouteIn = ["welcome","show",  "videos", "account","movies", "about","category", "terms-conditions", "privacy-policy", "smartTv", "all", "history"];
        if (window.innerWidth <= 575) hideSearchRouteIn = hideSearchRouteIn.concat(['play', 'home'])
        if(config.subDomain === 'lv') hideSearchRouteIn = hideSearchRouteIn.concat(['favorites'])
        let pathname = this.props.location.pathname.split('/')[1];
        if (~hideSearchRouteIn.indexOf(pathname)) {
            return false;
        }
        return true;
    }

    showMenu() {
        let hideMenuRoute = [];
        if((config.title === 'es'|| config.title === 'bidiotv') && window.innerWidth <= 575){
            hideMenuRoute = ["welcome", "category","account","history"]
        }
        else{
            hideMenuRoute = ["welcome", "category"]
        }
           let pathname = this.props.location.pathname.split('/')[1];
        if (~hideMenuRoute.indexOf(pathname)) {
            return true;
        }
        return false;
    }


    showUnsubscribe() {
        let hideUnsubscribeRoute = ["welcome", "category"],
            pathname = this.props.location.pathname.split('/')[1];
        if (~hideUnsubscribeRoute.indexOf(pathname)) {
            return true;
        }
        return false;
    }

    hideHomeRoute() {
        let hideHomeRoute = [ "404", "500", "restricted","cokies_policy"],
            pathname = this.props.location.pathname.split('/')[1];
        if (~hideHomeRoute.indexOf(pathname)) {
            return false;
        }
        return true;
    }
    feedbackModalToggle() {
        this.setState({
            feedbackModal: !this.state.feedbackModal
        });
      }

    render() {
        let uid = this.props.access.uid;
        let routes_align_center = ["/login", "/404", "/500", "/restricted", "/about" ],
        app_body_class = (routes_align_center.indexOf(this.props.location.pathname) == -1) ? "app-body flex-column": "app-body flex-row align-items-center";
        if(browser.os==="Android OS" || browser.os==='ios'){
        if((browser.name==="chrome" && parseInt(browser.version)<51) 
        || (browser.name==="ie" && parseInt(browser.version)< 10)
        || (browser.name==="firefox" && parseInt(browser.version)< 52)
        || (browser.name==="safari" && parseInt(browser.version)< 7)
        || (browser.name==="edge" && parseInt(browser.version)< 10)
        || (browser.name==="opera" && parseInt(browser.version)< 16)
     ){
          return(
              <div style={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh',width:'100%'}}>
                <div style={{height:"20vh",width:"100%",flexDirection:"column",display:'flex',alignItems:'center',justifyContent:'center',backgroundColor:'red'}}>
                    <h3 > {browser.name} (version: {browser.version}) unsupported</h3>
                    <h4 >Please download latest browser version. </h4>
                </div>
              </div>
          )
        }
    }
        if (!this.props.splash.hideSplash || this.props.location.pathname == "/") {
            return <Route path="/" name="Splash Screen" component={SplashScreen}/>
        } else {
            let cookieMsg, moreInfo, privacyLink, btnText, to;
            const productNameCH = config.newDomain === 'vidflixz' ? 'Vidflixz' : 'MobioTV'
            const productNameRS = config.newDomain === 'telemovil' ? 'Telemovil' : 'MobioTV'
            if(this.props.currentLang == 'ar') {
              cookieMsg = `مرحبا! يستخدم موقعنا ملفات تعريف الارتباط لضمان حصولك على أفضل تجربة ممكنة مع ${config.newDomain === 'mobiofitplus' ? 'Mobiofitplus':'MobioTV'}.`;
              moreInfo = 'مزيد من المعلومات';
              privacyLink = '/privacy-policy';
              btnText = 'فهمتك';
              to = '/privacy-policy';
            }
            else if( config.newDomain === 'telemovil' && config.lang === 'en') {
              cookieMsg = 'Hi! Our website uses cookies to ensure you get the best possible experience with Tele Movil.';
              moreInfo = 'more info';
              privacyLink = '/privacy-policy';
              btnText = 'Got it!';
              to = '/privacy-policy';
            }
            else if( config.newDomain === 'fitness-bay') {
              cookieMsg = 'Hi! Our website uses cookies to ensure you get the best possible experience with Fitness Bay';
              moreInfo = 'more info';
              privacyLink = '/privacy-policy';
              btnText = 'Got it!';
              to = '/privacy-policy';
            }
            else if( config.newDomain === 'fun-box') {
              cookieMsg = 'Hi! Our website uses cookies to ensure you get the best possible experience with Fun Box';
              moreInfo = 'more info';
              privacyLink = '/privacy-policy';
              btnText = 'Got it!';
              to = '/privacy-policy';
            }
            else if( config.subDomain === 'es.trendme') {
              cookieMsg = 'Nuestro sitio web utiliza cookies para garantizar la mejor experiencia posible con Trendme.';
              moreInfo = 'más información';
              privacyLink = '/privacy-policy';
              btnText = '¡Lo tengo!';
              to = '/privacy-policy';
            }
            else if( config.subDomain === 'eu.flamilingo') {
              cookieMsg = 'Nuestro sitio web utiliza cookies para garantizar la mejor experiencia posible con Flamilingo.';
              moreInfo = 'más información';
              privacyLink = '/privacy-policy';
              btnText = '¡Lo tengo!';
              to = '/privacy-policy';
            }
            else if( config.subDomain == 'gh') {
              cookieMsg = 'Hi! Our website uses cookies to ensure you get the best possible experience with MobioTV.';
              moreInfo = 'more info';
              privacyLink = 'http://n.mobiotv.com/gh/tnc-mobiotv?device=pc&offer=1';
              btnText = 'Got it!';
              to = `/?uid=${this.props.access.uid}`;
            }
            else if( config.subDomain == 'ee') {
              cookieMsg = 'Tere! Meie veebisait kasutab küpsiseid, et tagada sulle MobioTV-ga võimalikult hea kogemus.';
              moreInfo = 'rohkem infot';
              privacyLink = '/privacy-policy';
              btnText = 'Sain aru!';
              to = '/privacy-policy';
            }
            else if( config.subDomain == 'sn') {
              cookieMsg = 'Salut! Notre site Web utilise des cookies pour vous garantir la meilleure expérience possible avec MobioTV.';
              moreInfo = 'Plus d\'informations';
              privacyLink = '/privacy-policy';
              btnText = 'Je l\'ai!';
              to = '/privacy-policy';
            }
            else if (config.subDomain == 'be') {
                cookieMsg = 'Onze website maakt gebruik van cookies om ervoor te zorgen dat u de best mogelijke ervaring met touchnote krijgt.';
                moreInfo = 'Meer informatie';
                privacyLink = 'http://n.mobiotv.com/be/tnc-mobiotv?offer=1&_next=general_conditions.html';
                btnText = 'Begrijp ik!';
                to = `/?uid=${this.props.access.uid}`;
            }
            else if(config.subDomain == 'id'){
                cookieMsg = 'Hai! Situs web kami menggunakan cookie untuk memastikan Anda mendapatkan pengalaman terbaik dengan MobioTV.';
                moreInfo = 'info lebih lanjut';
                privacyLink = '/privacy-policy';
                btnText = 'Mengerti!';
                to = '/privacy-policy';
            }
            else if(config.subDomain == 'it'){
                cookieMsg = 'Salve! Il nostro sito Web utilizza cookie per assicurarti la migliore esperienza possibile con MobioTV.';
                moreInfo = 'maggiori informazioni';
                privacyLink = '/privacy-policy';
                btnText = 'Ok!';
                to = '/privacy-policy';
            }
            else if (config.subDomain == 'nl') {
                cookieMsg = 'Onze website maakt gebruik van cookies om ervoor te zorgen dat u de best mogelijke ervaring met touchnote krijgt.';
                moreInfo = 'Meer informatie';
                privacyLink = 'http://n.mobiotv.com/nl/tnc-mobiotv?offer=1&_next=general_conditions.html';
                btnText = 'Begrijp ik!';
                to = `/?uid=${this.props.access.uid}`;
            }
            else if (config.subDomain == 'se') {
                cookieMsg = 'Hej! Vår webbplats använder cookies för att säkerställa att du får den bästa möjliga upplevelsen med MobioTV.';
                moreInfo = 'mer information';
                privacyLink = 'http://n.mobiotv.com/nl/tnc-mobiotv?offer=1&_next=general_conditions.html';
                btnText = 'Jag förstår!';
                to = `/?uid=${this.props.access.uid}`;
            }
            else if(config.subDomain == 'iq'){
                cookieMsg ="مرحبا! يستخدم موقعنا ملفات تعريف الارتباط لضمان حصولك على أفضل تجربة ممكنة مع MobioTV.";
                moreInfo = 'more info';
                privacyLink = '/privacy-policy';
                btnText = 'Ok!';
                to = '/privacy-policy';
            }
            else if(config.lang == 'no'){
              cookieMsg =`Hei! Nettsiden vår bruker informasjonskapsler for å sikre at du får best mulig opplevelse med ${config.subDomain.includes('mobiofit') ? 'Mobiofit' : 'MobioTV'}.`;
              moreInfo = 'Mer info';
              privacyLink = 'http://n.mobiotv.com/no/tnc-mobiotv?offer=1';
              btnText = 'Skjønner!';
              to = `/?uid=${this.props.access.uid}`
          }
          else if(config.subDomain=='tr'){
            cookieMsg = 'Merhaba! Web sitemiz, touchnote ile mümkün olan en iyi deneyimi elde etmek için çerezleri kullanır.';
            moreInfo = 'Daha fazla bilgi';
            btnText = 'Anladım!';
            to = '/privacy-policy';
          }
          else if(config.subDomain=='tr.mobiofit'){
            cookieMsg = 'Merhaba! Web sitemiz, touchnote ile mümkün olan en iyi deneyimi elde etmek için çerezleri kullanır.';
            moreInfo = 'Daha fazla bilgi';
            btnText = 'Anladım!';
            to = '/privacy-policy';
          }
          else if(config.subDomain=='lv'){
            cookieMsg = "Sveiki! Mūsu vietnē tiek izmantotas sīkdatnes, lai nodrošinātu labāko iespējamo pieredzi ar MobioTV.";
            moreInfo = 'vairāk informācijas';
            btnText = 'Sapratu!';
            to = '/privacy-policy';
          }
          else if(config.subDomain=='lt'){
            cookieMsg = "Sveiki! Mūsų svetainė naudoja slapukus, kad jums užtikrintų geriausią patirtį MobioTV.";
            moreInfo = 'daugiau informacijos';
            btnText = 'Supratau!';
            to = '/privacy-policy';
          }
          else if(config.lang === 'sr'){
            cookieMsg = `Ћао! Наша веб локација користи колачиће како би осигурала најбоље могуће искуство на ${productNameRS}.`;
            moreInfo = 'више информација';
            btnText = 'разумем';
            to = '/privacy-policy';
          }
          else if(config.subDomain=='th'){
            cookieMsg = `สวัสดี! เว็บไซต์ของเราใช้คุกกี้เพื่อทำให้มั่นใจว่าคุณได้รับประสบการณ์ที่ดีที่สุดที่เป็นไปได้โดย MobioTV.`;
            moreInfo = 'ข้อมูลเพิ่มเติม';
            privacyLink = '/privacy-policy';
            btnText = 'เข้าใจแล้ว!';
            to = '/privacy-policy';
          }
          else if(config.subDomain=='gr'){
            cookieMsg = `Γεια! Ο ιστότοπός μας χρησιμοποιεί cookies για να διασφαλίσει ότι θα έχετε την καλύτερη δυνατή εμπειρία με το MobioTV.`;
            moreInfo = 'περισσότερες πληροφορίες';
            privacyLink = '/privacy-policy';
            btnText = 'Το έπιασα!';
            to = '/privacy-policy';
          }
          else if(config.subDomain=='ch' && config.lang=='de') {
            cookieMsg = `Hi! Unsere Website verwendet Cookies, um dir garantiert die bestmögliche Erfahrung mit ${productNameCH} zu bieten.`;
            moreInfo = 'Mehr Info';
            privacyLink = '/privacy-policy';
            btnText = 'Ich habs!';
            to = '/privacy-policy';
          }
          else if(config.subDomain=='ch' && config.lang=='fr') {
            cookieMsg = `Salut! Notre site Web utilise des cookies pour vous garantir la meilleure expérience possible avec ${productNameCH}.`;
            moreInfo = 'Plus d\'informations';
            privacyLink = '/privacy-policy';
            btnText = 'Je l\'ai!';
            to = '/privacy-policy';
          }
          else if(config.subDomain=='ch' && config.lang=='it') {
            cookieMsg = `Salve! Il nostro sito Web utilizza cookie per assicurarti la migliore esperienza possibile con ${productNameCH}.`;
            moreInfo = 'Maggiori Informazioni';
            privacyLink = '/privacy-policy';
            btnText = 'Ok!';
            to = '/privacy-policy';
          }
          else if (config.subDomain == "cz") {
            cookieMsg = `Dobrý den! Naše webové stránky používají soubory cookie, abychom vám zajistili co nejlepší zkušenost s MobioTV.`;
            moreInfo = "více informací";
            privacyLink = "/privacy-policy";
            btnText = "Jasné!";
            to = "/privacy-policy";
          }
          else if (config.lang === 'pt'){
            cookieMsg = `Olá! Nosso site usa cookies para garantir que você obtenha a melhor experiência possível com a MobioTV.`;
            moreInfo = "mais informações";
            privacyLink = "/privacy-policy";
            btnText = "Entendi!!";
            to = "/privacy-policy";
          } 
          else {
              cookieMsg = `Hi! Our website uses cookies to ensure you get the best possible experience with ${config.newDomain ==='mobiofitplus' ? 'Mobiofitplus' : config.subDomain.indexOf('mobiofit') >= 0 ? 'Mobiofit' : config.subDomain === 'ch' ? productNameCH : 'MobioTV'}.`;
              moreInfo = 'more info';
              privacyLink = '/privacy-policy';
              btnText = 'Got it!';
              to = '/privacy-policy';
          }
          const isChatbotDomain = config.subDomain === 'ae.mobiofit' || config.subDomain === 'sa.mobiofit'
          
          return (
              <div 
                //className="app ar"
                className="app"
              >
                <div>
                  <CookieConsent
                    location="bottom"
                    buttonText={btnText}
                    cookieName="MobiotvCookie"
                    style={{ background: "#2B373B" }}
                    buttonStyle={{
                      backgroundColor: "white",
                      fontSize: "13px",
                      margin: "5px",
                      marginRight: `${isChatbotDomain ? '10%' : '5px'}`
                    }}
                    contentStyle={{ flex: "none" }}
                  >
                    {cookieMsg}{" "}
                    { (config.subDomain == "be" || config.subDomain == "nl" || config.subDomain == "gh") ? (
                      <Link
                        onClick={e => (window.location = privacyLink)}
                        to={to}
                      >
                        <p style={{ color: "skyblue" }}>{moreInfo}</p>
                      </Link>
                    ) : (
                      <Link to="/privacy-policy">
                        <p style={{ color: "skyblue" }}>{moreInfo}</p>
                      </Link>
                    )}
                  </CookieConsent>
                </div>
                <Route
                  path="/login"
                  name="Login Page"
                  component={config.subDomain === 'tr' || config.subDomain==="tr.mobiofit" ? twoStepLogin : Login}
                ></Route>
                {this.hideHomeRoute() ? (
                  <div>
                    {this.props.location.pathname.split("/")[1] == "login" ? (
                      ""
                    ) : (
                      <Header
                        isAdmin={this.props.user.isAdmin}
                        showSearch={this.showSearch()}
                        showMenu={this.showMenu()}
                        {...this.props}
                        changeLang={this.props.changeLang}
                      />
                    )}

                    {window.innerWidth <= 575 && config.subDomain !== 'lv' ? (
                      <BottomMobileMenu showBottomMenu={this.props.location.pathname === '/login' ? false : true} changeLang={this.props.changeLang} />
                    ) : (
                      <Sidebar isAdmin={this.props.user.isAdmin} changeLang={this.props.changeLang} />
                    )}
                    <div className={app_body_class}></div>
                  </div>
                ) : (
                  ""
                )}

                <Route path="/404" name="Page 404" component={Page404} />
                <Route path="/500" name="Page 500" component={Page500} />
                <Route
                  path="/cokies_policy"
                  name="cokies policy"
                  component={CokiesPolicy}
                />
                <Route
                  path="/restricted"
                  name="Access Denied"
                  component={AccessDenied}
                />
                <PrivateRoute
                  path="/welcome"
                  name="Welcome Page"
                  component={Welcome}
                />
                <div>
                <PrivateRoute name="Home" component={Home}/>
                </div>
                {!(this.props.location.pathname.includes('/search') && window.innerWidth <= 575) ? <Footer isAdmin={this.props.user.isAdmin} /> :null}
                <Overlay isAdmin={this.props.user.isAdmin} />
                <ActivityIndicator isLoading={this.props.loader.isLoading} />
                <div
                  className="feedback-class"
                  style={['no', 'gr'].indexOf(config.subDomain) >= 0 ? {right:'-50px'} : config.subDomain === 'rs' ? {right: '-79px'} : {} }
                  onClick={this.feedbackModalToggle}
                >
                  <div>
                    <span>
                      <b>
                        <FormattedMessage
                          id="feedback"
                          defaultMessage="FEEDBACK"
                        />
                      </b>
                    </span>
                  </div>
                  <Feedback
                    feedbackModalToggle={this.feedbackModalToggle}
                    feedbackModal={this.state.feedbackModal}
                  />
                </div>
              </div>
            );
        }
    }
}

const mapStateToProps = (state) => {
    return {
        access: state.WelcomeReducer,
        account: state.AccountReducer,
        category: state.CategoryReducer,
        country: state.CountryReducer,
        domain: state.DomainReducer,
        favorite: state.FavoriteReducer,
        flashmessage: state.FlashMessageReducer,
        historyVideos: state.HistoryReducer,
        loader: state.ActivityIndicatorReducer,
        play: state.PlayReducer,
        search: state.SearchReducer,
        smartTV: state.SmartTVReducer,
        splash: state.SplashScreenReducer,
        user: state.AuthenticationReducer
    };
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        
    }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(App);


// WEBPACK FOOTER //
// ./src/containers/App.js